import MAutocomplete from './MAutocomplete.vue';

MAutocomplete.install = (app) => {
  app.component('MAutocomplete', MAutocomplete);
};

export { MAutocomplete };
